import { AgGridTable } from 'core/components';
import { TableLayoutType } from 'core/enums';
import { AgGridClientTableProvider } from 'core/states';
import { AgGridDataRow, ISelectionActionProps } from 'core/types';
import { useGetJobVendors } from 'jobs/hooks';
import { IJobVendor } from 'jobs/types';

import { RemoveVendorsButton, UpsertVendorButton } from './actions';
import { getColumnDefs } from './columns';

// Remove this after duplicate id problem is solved
const getRowId = (data: AgGridDataRow) =>
  `${data?.id}-${(data as IJobVendor)?.foreignContactEmail}`;

interface IProps {
  jobId: number;
  projectId: number;
}

export const VendorList = ({ jobId, projectId }: IProps) => {
  const { records, isLoading, loadingPercentage, currentPage } = useGetJobVendors({
    filters: { bomId: jobId },
  });

  const columnDefs = getColumnDefs();

  const actionButtons = () => {
    return [<UpsertVendorButton key="addVendorButton" jobId={jobId} projectId={projectId} />];
  };

  const selectionActionButtons = ({ selectedRows }: ISelectionActionProps) => {
    return [
      <RemoveVendorsButton
        key="removeVendorsButton"
        jobId={jobId}
        vendors={selectedRows as IJobVendor[]}
      />,
    ];
  };

  return (
    <AgGridClientTableProvider
      tableId="jobVendorList"
      entityType="Vendor"
      columnDefs={columnDefs}
      getRowId={getRowId}
      data={records}
      isDataLoading={isLoading}
      loadingPercentage={loadingPercentage}
      dataCurrentPage={currentPage}
      headerCheckbox
      layoutType={TableLayoutType.JOB_VENDORS}
      hasLayoutActions
    >
      <AgGridTable actionButtons={actionButtons} selectionActionButtons={selectionActionButtons} />
    </AgGridClientTableProvider>
  );
};
